<template>
	<modal ref="modal">
		<template #title>
			Dragonpay Status
		</template>
		<template #body>
			<div v-if="member!=null">
				<div class="form-floating mb-4">
					<div class="form-control">{{member.trans_num}}</div>
					<label class="form-label">Trans Number</label>
				</div>
				<div class="form-floating mb-4">
					<div class="form-control">{{member.dp_refno}}</div>
					<label class="form-label">Ref Number</label>
				</div>
				<div class="form-floating mb-4">
					<div class="form-control">{{member.bankbranch}}</div>
					<label class="form-label">Bank Branch</label>
				</div>
				<div class="form-floating mb-4">
					<div class="form-control">{{member.total}}</div>
					<label class="form-label">Amount</label>
				</div>
				<div class="form-floating mb-4">
					<div class="form-control">{{member.pf}}</div>
					<label class="form-label">Processing Fee</label>
				</div>
				<div class="form-floating mb-4">
					<div class="form-control">{{member.dp_message}}</div>
					<label class="form-label">Message</label>
				</div>
				<div class="form-floating mb-4">
					<div class="form-control">{{member.date_posted}}</div>
					<label class="form-label">Date Posted</label>
				</div>
				<div class="form-floating mb-4">
					<div class="form-control">{{member.settleDate}}</div>
					<label class="form-label">Settle Date</label>
				</div>
				<div class="form-floating mb-4">
					<div class="form-control">{{member.status_format}}</div>
					<label class="form-label">Status</label>
				</div>
			</div>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import { ref, reactive, toRef, toRefs, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia';

export default {
	props: {

	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const member = ref(null);

		const setPayoutInfo = (data)=>{
								member.value = data;

								if(member.value.status!='S')
								{	
									checkDragonPay(member.value.trans_num);
								}
							}

		const checkDragonPay = (trans_number) => {
								
								// Inertia.get('check-status/'+trans_number,{
								// 	preserveState: true,
								// 	preserveScroll: true,
								// 	only:['payoutRequest','api_response','filters','flash'],
								// 	onSuccess:()=>{
								// 		console.log(props.api_response);
								// 	}
								// })

								axios.get('/api/admin/affiliate-program/check-status/'+trans_number)
								   .then(res => {
								      if(res.data.result=='success')
								      {
								      	member.value.dp_refno 		= res.data.data.dp_refno;
								      	member.value.dp_message 	= res.data.data.dp_message;
								      	member.value.settleDate 	= res.data.data.settleDate;
								      	member.value.status 		= res.data.data.status;
								      	member.value.status_format 	= res.data.data.status_format;
								      }
								      console.log(res)
								   })
							}


		return {
			modal,
			setPayoutInfo,
			member,
			checkDragonPay,
			toggleModal,
		}
	},
}
</script>
